import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getReceivingListData, getReceivingVendorList } from "src/api/common";
import { resetStore } from "src/store/actions";
import { mapAlternateValue, isDsdOrWt } from "src/utils/genericFunctions";
import { defaultEmptyValue } from "src/config/constants/genericConstants";

export const fetchReceivingListData = createAsyncThunk(
  "receiving/fetchReceivingListData",
  (payload: any) => getReceivingListData(payload)
);

export const fetchReceivingVendorList = createAsyncThunk(
  "receiving/fetchReceivingVendorListData",
  (payload: {
    storeId: any;
    fromDate: string;
    toDate: string;
    signal?: AbortSignal | null;
  }) => getReceivingVendorList(payload)
);

const initialState: any = {
  receivingList: [],
  recordsCount: null,
  status: "idle",
  error: null,
  vendorList: []
};

const receivingListSlice = createSlice({
  name: "receivingList",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(resetStore, (state, action) => {
        return initialState;
      })
      .addCase(fetchReceivingListData.pending, (state) => {
        state.status = "pending";
        state.receivingList = [];
      })
      .addCase(fetchReceivingListData.fulfilled, (state, { payload }) => {
        state.status = "idle";
        state.receivingList = payload?.data?.data?.map((data: any) => {
          const receivingType = mapAlternateValue(data?.receivingType);
          return {
            ...data,
            receivingType,
            cases: isDsdOrWt(data?.receivingType)
              ? Math.trunc(data?.cases)
              : defaultEmptyValue,
            margin: isDsdOrWt(data?.receivingType)
              ? data?.margin
              : { margin: null }
          };
        });
        state.recordsCount = payload.data.recordsCount;
      })
      .addCase(fetchReceivingListData.rejected, (state, action) => {
        state.status = "error";
        state.receivingList = [];
        state.recordsCount = null;
      })
      .addCase(fetchReceivingVendorList.fulfilled, (state, { payload }) => {
        state.vendorList = Object.entries(payload?.data).map(
          ([key, value]: any) => ({
            id: key,
            name: value?.trim()
          })
        );
      })
      .addCase(fetchReceivingVendorList.rejected, (state) => {
        state.status = "error";
      });
  }
});

export default receivingListSlice.reducer;
